import {Action, Module, Mutation} from 'vuex-module-decorators'
import store from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import StudyPatientDto = MdbsCore.StudyPatientDto;
import IStudyPatientCreateDto = MdbsCore.IStudyPatientCreateDto;
import IStudyPatientUpdateDto = MdbsCore.IStudyPatientUpdateDto;
import StudyPatientUpdateDto = MdbsCore.StudyPatientUpdateDto;
import StudyPatientCreateDto = MdbsCore.StudyPatientCreateDto;
import StudyPatientDeleteDto = MdbsCore.StudyPatientDeleteDto;

const studyPatientClient = new MdbsCore.StudyPatientClient();

@Module({namespaced: true, name: 'studyPatient', store: store})
export default class StudyPatientModule extends BaseModule {
    studyPatient: StudyPatientDto = new StudyPatientDto();

    @Mutation
    setStudyPatient(studyPatient: StudyPatientDto) {
        this.studyPatient = studyPatient;
    }

    @Mutation
    reset() {
        this.studyPatient = new StudyPatientDto();
    }

    @Action({rawError: true})
    async loadById(id: string) {
        await this.execute(async () => this.setStudyPatient(await studyPatientClient.getById(id))
        ).catch(() => this.reset());
    }

    @Action({rawError: true})
    async create(studyPatient: IStudyPatientCreateDto) {
        await this.execute(async () => {
            const createdStudyPatient = await studyPatientClient.create(new StudyPatientCreateDto(studyPatient));
            this.setStudyPatient(createdStudyPatient);
        }).catch();
    }

    @Action({rawError: true})
    async update(studyPatient: IStudyPatientUpdateDto) {
        await this.execute(async () => {
            const updatedPatient = await studyPatientClient.update(studyPatient.id, new StudyPatientUpdateDto(studyPatient));
            this.setStudyPatient(updatedPatient)
        }).catch();
    }

    @Action({rawError: true})
    async delete(id: string) {
        await this.execute(async () => {
            await studyPatientClient.delete(id, new StudyPatientDeleteDto());
            this.reset()
        }).catch();
    }
}
